module.exports = __webpack_public_path__ + "fonts/font.148f3b30.ttf";